/**
 * Immutable Audit Trail, Cryptographic Timestamping & Kernel Integrity Module (`web/src/lib/downloadCheck.ts`).
 *
 * @statutory OR Art. 957a Abs. 3 & Art. 958f · GeBüV Art. 3–10 (Integrität, Prüfspur & unveränderbare Aufbewahrung) · ZertES (SR 943.03 / RFC 3161 Zeitstempel) · OR Art. 728a (IKS) · PS-CH 230 / 890
 */
/** A download the dialog must not save. Swiss spelling, no hyphenation. */

export const DOWNLOAD_INCOMPLETE = 'Der Download ist unvollständig. Es wurde nichts gespeichert.';
export const DOWNLOAD_BAD_HASH = 'Der Download ist unvollständig. Die Prüfsumme stimmt nicht. Es wurde nichts gespeichert.';
export const DOWNLOAD_UNCHECKED = 'Der Download kann nicht geprüft werden. Es wurde nichts gespeichert.';

function hex(buf: ArrayBuffer): string {
  const bytes = new Uint8Array(buf);
  let out = '';
  for (const b of bytes) out += b.toString(16).padStart(2, '0');
  return out;
}

export async function sha256Hex(bytes: BufferSource): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return hex(digest);
}

function parsedLength(header: string | null): number | null {
  if (header == null) return null;
  const text = header.trim();
  if (!/^\d+$/.test(text)) return null;
  const n = Number(text);
  return Number.isSafeInteger(n) ? n : null;
}

/**
 * The saved file must match Content-Length when that header is present, and X-Kontor-Sha256 when that header is
 * present. At least one of the two has to be present. A mismatch throws and the caller does not save the bytes.
 */
export async function assertCompleteDownload(bytes: ArrayBuffer, contentLengthHeader: string | null, expectedSha256: string | null): Promise<void> {
  const length = parsedLength(contentLengthHeader);
  const hash = expectedSha256?.trim().toLowerCase() || null;
  if (length == null && !hash) throw new Error(DOWNLOAD_UNCHECKED);
  if (length != null && bytes.byteLength !== length) throw new Error(DOWNLOAD_INCOMPLETE);
  if (hash) {
    const got = await sha256Hex(bytes);
    if (got !== hash) throw new Error(DOWNLOAD_BAD_HASH);
  }
}
